<!--
<ion-header>
  <ion-toolbar>
    <ion-buttons slot="start">
      <ion-menu-button></ion-menu-button>
    </ion-buttons>
    <ion-title>{{'Coupon.Title' | translate}}</ion-title>
  </ion-toolbar>
</ion-header>
-->


<div class="container" >
  <div class="full-promo" #fullPromo>
    <div class="view-promo-front" #promoFront>

      @if (isMobile) {
        <button class="close-btn" (click)="closeModel()">✕</button>
      }


      <div class="promo-img-container">
        @if (promotion.visualConfig.imgURL) {
          <img class="promo-img" [src]="getpromoImage(promotion)">
        }
      </div>

      <div class="promo-description-container">
        <!-- Currently don't a description have but may want one -->
      </div>


      <div class="ApplySection">
        <!-- add the code bar later-->
        <!--Add QR code later-->

        <div class="PromoCode">{{'promo code: ' | uppercase}}&nbsp;<p class="promoTextFont">{{ promotion.promotionalCode | uppercase }}</p></div>
        <button class="applyButton" (click)="applypromo()">{{'Apply to checkout' | uppercase}}</button>
      </div>

      <div class="termline">
        <div class="detail"><a class="promo-terms" (click)="flip()">({{'Coupon.Terms' | translate | uppercase}})</a></div>
      </div>

    </div>

    <div (click)="turnBack()" class="view-promo-back hide" #promoBack>

      @if (isMobile) {
        <button class="close-btn close-right" (click)="closeModel()">✕</button>
      }

      <div    class="back-container" id="backContainer">
        <div class="title-heading">
          <div class="terms">{{'Coupon.Term' | translate}}</div>
        </div>
        <div class="conditions">
          <p>{{ promotion.taC.translations[translationService.getLanguage()] }}</p>
        </div>
      </div>
    </div>

  </div>
</div>